import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  icon?: React.ReactNode;
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  icon,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'group relative overflow-hidden inline-flex items-center justify-center font-semibold rounded-lg transition-all duration-300 ease-out';
  const variants = {
    primary: 'bg-brand-accent text-brand-dark hover:bg-brand-accentHover shadow-[0_0_20px_rgba(245,158,11,0.3)] hover:shadow-[0_0_40px_rgba(245,158,11,0.6)] hover:-translate-y-0.5 animate-cta-pulse',
    secondary: 'bg-white text-brand-dark hover:bg-slate-200 hover:-translate-y-0.5',
    outline: 'border border-slate-700 text-white hover:bg-slate-800 hover:border-slate-600'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm gap-2',
    md: 'px-6 py-3 text-base gap-2',
    lg: 'px-8 py-4 text-lg gap-3'
  };
  const isPrimary = variant === 'primary';
  return <motion.a whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} {...props} data-id="element-344">
      {isPrimary && <span aria-hidden="true" className="pointer-events-none absolute inset-0 -translate-x-full group-hover:translate-x-full transition-transform duration-1000 ease-out bg-gradient-to-r from-transparent via-white/40 to-transparent" data-id="element-345" />}
      <span className="relative z-10 inline-flex items-center gap-[inherit]" data-id="element-346">
        {children}
        {icon && <span className="flex-shrink-0" data-id="element-347">{icon}</span>}
      </span>
    </motion.a>;
}